import React from 'react';
import { Redirect } from 'react-router-dom';
import { Alert } from 'antd';
import LoaderCard from '../shared/LoaderCard';
import useWebsiteSetupStatus from './hooks/useWebsiteSetupStatus';

type Props = {
    websiteGuid: string | undefined;
    children: JSX.Element | JSX.Element[];
};

export default function DomainSetupCheck({ websiteGuid, children }: Props) {
    const { websiteStatus, isLoadingWebsiteStatus, isWebsiteStatusError } = useWebsiteSetupStatus(websiteGuid);

    const shouldRedirectToSetup = !!websiteStatus && (websiteStatus.status === 'importing_sitemaps' || websiteStatus.status === 'waiting_for_user_input');
    const shouldRenderChildren = !!websiteStatus && websiteStatus.status === 'completed';

    return (
        <>
            {isLoadingWebsiteStatus && <LoaderCard />}

            {isWebsiteStatusError && (
                <Alert
                    showIcon
                    type="error"
                    message="Something went wrong!"
                    description="Please try again or contact support."
                />
            )}

            {shouldRedirectToSetup && <Redirect to={{ pathname: '/deep-analysis/setup-domain', search: `?w_guid=${websiteGuid}` }} />}

            {shouldRenderChildren && <>{children}</>}
        </>
    );
}
